import {
  ActivityIcon,
  BuildingIcon,
  ClockIcon,
  CreditCardIcon,
  MegaphoneIcon,
  SettingsIcon,
  UsersIcon,
} from '@saas-kit/ui/shell/icons';
import type { NavEntry } from '@saas-kit/ui/shell';

export const adminNav: NavEntry[] = [
  {
    id: 'dashboard',
    to: '/',
    labelKey: 'nav.dashboard',
    icon: ActivityIcon,
    end: true,
  },
  {
    id: 'tenants',
    to: '/tenants',
    labelKey: 'nav.tenants',
    icon: BuildingIcon,
  },
  {
    id: 'users',
    to: '/users',
    labelKey: 'nav.users',
    icon: UsersIcon,
  },
  {
    id: 'plans',
    to: '/billing/plans',
    labelKey: 'nav.plans',
    icon: CreditCardIcon,
  },
  {
    id: 'audit',
    to: '/audit',
    labelKey: 'nav.audit',
    icon: ClockIcon,
  },
  {
    id: 'announcements',
    to: '/announcements',
    labelKey: 'nav.announcements',
    icon: MegaphoneIcon,
  },
  {
    id: 'settings',
    to: '/settings',
    labelKey: 'nav.settings',
    icon: SettingsIcon,
  },
];
